import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableauComponent } from './tableau/tableau.component';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [TableauComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class TableauModule { }
